var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "style=stroke"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-short-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20554 4.48407C7.92066 4.78477 7.93349 5.25947 8.23419 5.54434L14.0905 11.0924C14.6109 11.5855 14.6109 12.4143 14.0905 12.9073L8.2342 18.4554C7.9335 18.7403 7.92067 19.215 8.20554 19.5157C8.49041 19.8164 8.96511 19.8292 9.26581 19.5443L15.1221 13.9962C16.2671 12.9116 16.2671 11.0882 15.1221 10.0035L9.26581 4.45541C8.96511 4.17054 8.49041 4.18337 8.20554 4.48407Z",
    fill: "#91e1f9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.b6df4448fc84d855f3b6af9a2806b574.svg";
export { ForwardRef as ReactComponent };